import { useNumberFieldInfo, useTsController } from "@ts-react/form";
import React, { useId } from "react";
import type { TextInput } from "react-native";
import type { IconProps } from "@tamagui/helpers-icon";
import { BentoInput } from "../bento/inputParts";
import { Fieldset } from "./Fieldset";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
import type { InputFieldProps } from "./InputField";
type NumberFieldProps = InputFieldProps & {
  rightIcon?: React.ComponentType<IconProps>;
  iconProps?: IconProps;
};
export const NumberField = (props: NumberFieldProps) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<number>();
  const {
    label,
    defaultValue,
    isOptional,
    placeholder,
    minValue,
    maxValue
  } = useNumberFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const {
    size,
    disabled: disabledProp,
    rightIcon: RightIcon,
    iconProps,
    ...inputProps
  } = props;
  const inputRef = React.useRef<TextInput | null>(null);
  const id = useId();
  const inputId = `${id}_input`;
  const disabled = isSubmitting || disabledProp;
  const setInputFocus = () => {
    if (inputRef.current && !inputRef.current.isFocused()) {
      inputRef.current.focus();
    }
  };
  return <Fieldset data-sentry-element="Fieldset" data-sentry-component="NumberField" data-sentry-source-file="NumberField.tsx">
      <BentoInput theme={error ? "red_alt2" : "granted"} size={size || "$4"} key={inputId} data-sentry-element="BentoInput" data-sentry-source-file="NumberField.tsx">
        {label ? <BentoInput.Label theme="alt1" htmlFor={inputId} flexGrow={0} alignSelf="flex-start">
            {label}
            {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
          </BentoInput.Label> : null}
        <BentoInput.Box onPress={() => setInputFocus()} disabled={disabled} data-sentry-element="BentoInput.Box" data-sentry-source-file="NumberField.tsx">
          <BentoInput.Area id={inputId} placeholder={placeholder} overflow="hidden" flex={1} inputMode="numeric" keyboardType="number-pad" hasLabel={!!label} value={field.value?.toString() || ""} onChangeText={text => {
          const num = Number(text);
          if (Number.isNaN(num)) {
            if (!field.value) {
              field.onChange(defaultValue);
            }
            return;
          }
          if (typeof maxValue !== "undefined" && num > maxValue) {
            field.onChange(minValue);
            return;
          }
          if (typeof minValue !== "undefined" && num < minValue) {
            field.onChange(minValue);
            return;
          }
          field.onChange(num);
        }} onBlur={field.onBlur} disabled={disabled} ref={ref => {
          field.ref(ref);
          inputRef.current = ref;
        }} {...inputProps} data-sentry-element="BentoInput.Area" data-sentry-source-file="NumberField.tsx" />
          {RightIcon ? <BentoInput.Icon paddingHorizontal="$3">
              <RightIcon color="$color12" strokeWidth={2} {...iconProps} />
            </BentoInput.Icon> : null}
        </BentoInput.Box>
        <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="NumberField.tsx" />
      </BentoInput>
    </Fieldset>;
};